import { useContext } from 'preact/hooks';
import { DefaultFormContext, FormContext } from './FormContext';

/**
 * Utility hook for consuming the FormContext
 *
 * @returns The value of closest FormContext provider
 */
function useFormContext() {
  const context = useContext(FormContext);
  // merge the returned context into the default context so that all props are specified
  const contextWithDefaults = Object.assign({}, DefaultFormContext, context);
  return contextWithDefaults;
}

export { useFormContext };
